"use client";
'use strict';

var React = require('react');
var browser = require('@sravni/ab-testing-sdk/lib/browser');
var Context = require('./Context.js');

function ControlledAbTestingProvider(props) {
    const { value: params, children } = props;
    const sdk = React.useMemo(() => (params ? new browser.AbTestingSdk(params) : Context.DEFAULT_VALUE), [params]);
    return React.createElement(Context.AbTestingContext.Provider, { value: sdk }, children);
}

exports.ControlledAbTestingProvider = ControlledAbTestingProvider;
//# sourceMappingURL=Controlled.js.map
